import { useContext } from 'react'

import { Grid } from '@material-ui/core'
import { EditContext } from 'Components/Hooks/ContextEdit'
import PictureCardWithZoom from 'Components/UI/Atoms/PictureCard/PictureCardWithZoom'
import img1 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/1.jpg'
import img2 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/2.jpg'
import img3 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/3.jpg'
import img4 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/4.jpg'
import img5 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/5.jpg'
import img6 from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Files/Tabs/Assets/6.jpg'

const Station = (props) => {
  const { formEdit } = props
  const [edit] = useContext(EditContext)

  const titles = [
    {
      id: 1,
      name: 'Foto frente',
      img: !formEdit.fotografias[0] ? img1 : formEdit.fotografias[0],
    },
    {
      id: 2,
      name: 'Foto izquierda',
      img: !formEdit.fotografias[1] ? img2 : formEdit.fotografias[1],
    },
    {
      id: 3,
      name: 'Foto atrás',
      img: !formEdit.fotografias[2] ? img3 : formEdit.fotografias[2],
    },
    {
      id: 4,
      name: 'Foto derecha',
      img: !formEdit.fotografias[3] ? img4 : formEdit.fotografias[3],
    },
    {
      id: 5,
      name: 'Foto motor',
      img: !formEdit.fotografias[4] ? img5 : formEdit.fotografias[4],
    },
    {
      id: 6,
      name: 'Foto interior',
      img: !formEdit.fotografias[5] ? img6 : formEdit.fotografias[5],
    },
  ]

  return (
    <div>
      <Grid container alignContent="center" justify="center" spacing={2}>
        {titles.map((item, index) => (
          <Grid item xs={12} xl={4} sm={6} md={4}>
            <PictureCardWithZoom
              img={!formEdit.fotografias[index] ? item.img : formEdit.fotografias[index]}
              alt={item.name}
              txt={item.name}
              edit={edit}
              index={index + 1}
              id={formEdit.id}
              swipes={titles}
              editDelete={false}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
export default Station
